module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"roof":"Dach","fassade":"Fassade","editRoofLayer":"Dach bearbeiten","viewRoofLayer":"Dach ansehen","close":"Schliessen","googleMaps":"Google Maps","swissGis":"map.geo.admin.ch","cantonZhGisAv":"Amtliche Vermessung Kanton ZH","oerebZhGis":"ÖREB Kanton ZH","loading":"Karte wird geladen..."}}')
  delete Component.options._Ctor
}
